const state = {
  user: undefined
}

const getters = {
  user: state => state.user
}

const types = {
  setUser: 'user/setUser'
}

const mutations = {
  [types.setUser] (state, object) {
    state.user = object
  }
}

const actions = {
  setUserAction ({commit}, object) {
    commit(types.setUser, object)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
